'use client';

import { c as _c } from "react/compiler-runtime";
import { toast } from '@repo/design-system/components/ui/toaster';
import { useT } from '@repo/i18n/components/i18n.client';
import { useGetCustomMarkersQuery, useGetCustomUserPinQuery } from '@repo/store/maps/api/mapsApi';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectIsAuthenticated } from '@repo/store/maps/slices/auth';
import { selectCustomPins, selectExternalMapId, selectMapData } from '@repo/store/maps/slices/mapData';
import { useCallback, useEffect, useState } from 'react';
import { useCustomPinOperations } from './useCustomPinOperations';
import { useMapPinOperations } from './useMapPinOperations';
export function useCustomPinUrlHandler(t0) {
  const $ = _c(32);
  const isMapInitialized = t0 === undefined ? false : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  const mapData = useAppSelector(selectMapData);
  const customPins = useAppSelector(selectCustomPins);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const {
    selectMarkerInMap
  } = useMapPinOperations();
  const {
    startAddingCustomPin
  } = useCustomPinOperations();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const checkForCustomPinUrl = _temp;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = checkForCustomPinUrl();
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const customPinId = t2;
  const externalMapId = useAppSelector(selectExternalMapId);
  const t3 = !customPinId || !isAuthenticated;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      skip: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    data: customPinData,
    isLoading: isLoadingCustomPinData,
    error: customPinDataError
  } = useGetCustomUserPinQuery(customPinId ?? "", t4);
  const t5 = !isAuthenticated || !externalMapId;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      skip: t5,
      refetchOnMountOrArgChange: true
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const {
    data: customMarkersData,
    isLoading: isLoadingCustomMarkers
  } = useGetCustomMarkersQuery(externalMapId ?? "", t6);
  const cleanUpUrlParams = _temp2;
  let t7;
  if ($[6] !== customMarkersData || $[7] !== customPinData || $[8] !== customPins || $[9] !== isAuthenticated || $[10] !== isLoadingCustomMarkers || $[11] !== isMapInitialized || $[12] !== mapData?.geojson || $[13] !== selectMarkerInMap || $[14] !== startAddingCustomPin || $[15] !== t) {
    t7 = () => {
      if (!customPinId) {
        return;
      }
      if (!isAuthenticated) {
        toast({
          title: t(_temp3),
          description: t(_temp4),
          variant: "warning"
        });
        setIsLoginModalOpen(true);
        cleanUpUrlParams();
        return;
      }
      if (!isMapInitialized) {
        return;
      }
      if (isLoadingCustomMarkers) {
        return;
      }
      const existingPinInMap = mapData?.geojson.features.find(feature => feature.properties.externalId === customPinId && feature.properties.isCustomPin);
      const existingPinInCustomPins = customPins.find(feature_0 => feature_0.properties.externalId === customPinId);
      const existingPinInCustomMarkers = customMarkersData?.find(feature_1 => feature_1.properties.externalId === customPinId);
      const existingPin = existingPinInMap || existingPinInCustomPins || existingPinInCustomMarkers;
      if (existingPin) {
        selectMarkerInMap(customPinId, {
          feature: existingPin,
          flyTo: true
        });
        cleanUpUrlParams();
        return;
      }
      if (customPinData) {
        startAddingCustomPin({
          coordinates: customPinData.coordinates.coordinates,
          title: customPinData.title,
          description: customPinData.description,
          color: customPinData.properties?.color || "#ff6b6b"
        });
      }
      cleanUpUrlParams();
    };
    $[6] = customMarkersData;
    $[7] = customPinData;
    $[8] = customPins;
    $[9] = isAuthenticated;
    $[10] = isLoadingCustomMarkers;
    $[11] = isMapInitialized;
    $[12] = mapData?.geojson;
    $[13] = selectMarkerInMap;
    $[14] = startAddingCustomPin;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== customMarkersData || $[18] !== customPinData || $[19] !== customPins || $[20] !== isAuthenticated || $[21] !== isLoadingCustomMarkers || $[22] !== isMapInitialized || $[23] !== mapData || $[24] !== selectMarkerInMap || $[25] !== startAddingCustomPin || $[26] !== t) {
    t8 = [customPinId, isAuthenticated, isMapInitialized, isLoadingCustomMarkers, mapData, customPins, customMarkersData, customPinData, startAddingCustomPin, cleanUpUrlParams, t, selectMarkerInMap];
    $[17] = customMarkersData;
    $[18] = customPinData;
    $[19] = customPins;
    $[20] = isAuthenticated;
    $[21] = isLoadingCustomMarkers;
    $[22] = isMapInitialized;
    $[23] = mapData;
    $[24] = selectMarkerInMap;
    $[25] = startAddingCustomPin;
    $[26] = t;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  useEffect(t7, t8);
  let t9;
  if ($[28] !== customPinDataError || $[29] !== isLoadingCustomPinData || $[30] !== isLoginModalOpen) {
    t9 = {
      isHandlingCustomPin: !!customPinId,
      isLoadingCustomPin: isLoadingCustomPinData,
      customPinError: customPinDataError,
      isLoginModalOpen,
      setIsLoginModalOpen
    };
    $[28] = customPinDataError;
    $[29] = isLoadingCustomPinData;
    $[30] = isLoginModalOpen;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
}
function _temp4($_0) {
  return $_0.login_required_for_custom_pin_description;
}
function _temp3($) {
  return $.login_required_for_custom_pin;
}
function _temp2() {
  const url_0 = new URL(window.location.href);
  url_0.searchParams.delete("isCustomPin");
  url_0.searchParams.delete("location");
  window.history.replaceState({}, "", url_0.toString());
}
function _temp() {
  if (typeof window === "undefined") {
    return null;
  }
  const url = new URL(window.location.href);
  const isCustomPin = url.searchParams.get("isCustomPin");
  const location = url.searchParams.get("location");
  if (isCustomPin === "true" && location) {
    return location;
  }
  return null;
}